import { render, staticRenderFns } from "./CustomConfig.vue?vue&type=template&id=0fa68a8f&scoped=true&"
import script from "./CustomConfig.vue?vue&type=script&lang=js&"
export * from "./CustomConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomConfig.vue?vue&type=style&index=0&id=0fa68a8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa68a8f",
  null
  
)

export default component.exports